import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import { useCreationModal } from './CreateLanguagePackModal';
import LanguagePackList from './LanguagePackList';

const LanguagePackListPage = () => {
    const { t } = useTranslation('languagePackList');
    const { permissions: accountPermissions } = useAccount();
    const creationModal = useCreationModal();

    const extra = hasPermissions(accountPermissions, [permissionKind.createLanguagePack]) ? (
        <Button icon={<PlusOutlined />} onClick={creationModal.open} type="primary">
            {t('languagePackList:actions.newLanguage')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('languagePackList:title')}>
            <LanguagePackList />
            {creationModal.render()}
        </ConsolePageWithHeader>
    );
};

export default LanguagePackListPage;
